<template>
  <div class="table_container">
    <!-- 历年年份汇率 -->
    <div class="third_title">
      历年年份汇率
    </div>
    <table>
      <tbody align="center">
        <tr>
          <th width="100px">
            <span style="color: #F56C6C">*</span>货币兑换关系
          </th>
          <th width="50px">周期</th>
          <th colspan="4">2022年</th>
          <th colspan="4">2023年</th>
          <th colspan="4">2024年</th>
        </tr>
        <tr>
          <td rowspan="2" @click="handleColumn('currencyExchangeRelationship')">
            <el-input
              v-if="editField === 'currencyExchangeRelationship'"
              ref="focusRef"
              v-model="form.currencyExchangeRelationship"
              size="mini"
              placeholder="请输入"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input>
            <span v-else>
              {{ form.currencyExchangeRelationship }}
            </span>
          </td>
          <th>季度</th>
          <th v-for="(item, index) in Qlist" :key="index">
            {{ item.quarter }}
          </th>
        </tr>
        <tr>
          <th>汇率</th>
          <td
            v-for="(item, index) in Qlist"
            :key="index"
            @click="handleColumn(item.exchangeRateField)"
          >
            <el-input-number
              v-if="editField === item.exchangeRateField"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="2"
              v-model="form[item.exchangeRateField]"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form[item.exchangeRateField] }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- 历史年份外汇储备（单位：万美元；进口覆盖天数=外汇储备总额/进口总额） -->
    <div class="third_title">
      历史年份外汇储备（单位：万美元；进口覆盖天数=外汇储备总额/进口总额）
    </div>
    <table>
      <tbody align="center">
        <tr>
          <th width="175px">周期</th>
          <th colspan="4">2022年</th>
          <th colspan="4">2023年</th>
          <th colspan="4">2024年</th>
        </tr>
        <tr>
          <th>季度</th>
          <th v-for="(item, index) in Qlist" :key="index">
            {{ item.quarter }}
          </th>
        </tr>
        <tr>
          <th>储备金额(亿美金)</th>
          <td
            v-for="(item, index) in Qlist"
            :key="index"
            @click="handleColumn(item.reserveAmount)"
          >
            <el-input-number
              v-if="editField === item.reserveAmount"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="2"
              v-model="form[item.reserveAmount]"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form[item.reserveAmount] }}
            </span>
          </td>
        </tr>
        <tr>
          <th>进口覆盖天数</th>
          <td
            v-for="(item, index) in Qlist"
            :key="index"
            @click="handleColumn(item.importCoverDays)"
          >
            <el-input-number
              v-if="editField === item.importCoverDays"
              ref="focusRef"
              class="number_input"
              :controls="false"
              :precision="1"
              v-model="form[item.importCoverDays]"
              size="mini"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ form[item.importCoverDays] }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { addOrUpdateEconomicEnvironmentApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      form: this.getForm(),
      rules: {
        currencyExchangeRelationship: [
          { required: true, message: "货币兑换关系不能为空", trigger: "blur" }
        ]
      },
      editField: "", // 编辑单元格
      Qlist: [
        {
          quarter: "Q1",
          exchangeRateField: "q1Rate22",
          reserveAmount: "q1Money22",
          importCoverDays: "q1Day22"
        },
        {
          quarter: "Q2",
          exchangeRateField: "q2Rate22",
          reserveAmount: "q2Money22",
          importCoverDays: "q2Day22"
        },
        {
          quarter: "Q3",
          exchangeRateField: "q3Rate22",
          reserveAmount: "q3Money22",
          importCoverDays: "q3Day22"
        },
        {
          quarter: "Q4",
          exchangeRateField: "q4Rate22",
          reserveAmount: "q4Money22",
          importCoverDays: "q4Day22"
        },
        {
          quarter: "Q1",
          exchangeRateField: "q1Rate23",
          reserveAmount: "q1Money23",
          importCoverDays: "q1Day23"
        },
        {
          quarter: "Q2",
          exchangeRateField: "q2Rate23",
          reserveAmount: "q2Money23",
          importCoverDays: "q2Day23"
        },
        {
          quarter: "Q3",
          exchangeRateField: "q3Rate23",
          reserveAmount: "q3Money23",
          importCoverDays: "q3Day23"
        },
        {
          quarter: "Q4",
          exchangeRateField: "q4Rate23",
          reserveAmount: "q4Money23",
          importCoverDays: "q4Day23"
        },
        {
          quarter: "Q1",
          exchangeRateField: "q1Rate24",
          reserveAmount: "q1Money24",
          importCoverDays: "q1Day24"
        },
        {
          quarter: "Q2",
          exchangeRateField: "q2Rate24",
          reserveAmount: "q2Money24",
          importCoverDays: "q2Day24"
        },
        {
          quarter: "Q3",
          exchangeRateField: "q3Rate24",
          reserveAmount: "q3Money24",
          importCoverDays: "q3Day24"
        },
        {
          quarter: "Q4",
          exchangeRateField: "q4Rate24",
          reserveAmount: "q4Money24",
          importCoverDays: "q4Day24"
        }
      ] // 季度
    };
  },
  methods: {
    init(data) {
      this.form = this.getForm(data || {});
    },
    // 获取表单数据
    getForm(data = {}) {
      return {
        currencyExchangeRelationship: data.currencyExchangeRelationship || "",
        q1Rate22: data.q1Rate22 ?? undefined,
        q2Rate22: data.q2Rate22 ?? undefined,
        q3Rate22: data.q3Rate22 ?? undefined,
        q4Rate22: data.q4Rate22 ?? undefined,
        q1Rate23: data.q1Rate23 ?? undefined,
        q2Rate23: data.q2Rate23 ?? undefined,
        q3Rate23: data.q3Rate23 ?? undefined,
        q4Rate23: data.q4Rate23 ?? undefined,
        q1Rate24: data.q1Rate24 ?? undefined,
        q2Rate24: data.q2Rate24 ?? undefined,
        q3Rate24: data.q3Rate24 ?? undefined,
        q4Rate24: data.q4Rate24 ?? undefined,

        q1Money22: data.q1Money22 ?? undefined,
        q2Money22: data.q2Money22 ?? undefined,
        q3Money22: data.q3Money22 ?? undefined,
        q4Money22: data.q4Money22 ?? undefined,
        q1Money23: data.q1Money23 ?? undefined,
        q2Money23: data.q2Money23 ?? undefined,
        q3Money23: data.q3Money23 ?? undefined,
        q4Money23: data.q4Money23 ?? undefined,
        q1Money24: data.q1Money24 ?? undefined,
        q2Money24: data.q2Money24 ?? undefined,
        q3Money24: data.q3Money24 ?? undefined,
        q4Money24: data.q4Money24 ?? undefined,

        q1Day22: data.q1Day22 ?? undefined,
        q2Day22: data.q2Day22 ?? undefined,
        q3Day22: data.q3Day22 ?? undefined,
        q4Day22: data.q4Day22 ?? undefined,
        q1Day23: data.q1Day23 ?? undefined,
        q2Day23: data.q2Day23 ?? undefined,
        q3Day23: data.q3Day23 ?? undefined,
        q4Day23: data.q4Day23 ?? undefined,
        q1Day24: data.q1Day24 ?? undefined,
        q2Day24: data.q2Day24 ?? undefined,
        q3Day24: data.q3Day24 ?? undefined,
        q4Day24: data.q4Day24 ?? undefined
      };
    },
    // 点击单元格编辑
    handleColumn(field) {
      if (this.$route.query.operateType === "查看") return;
      this.editField = field;
      this.$nextTick(() => {
        if (Array.isArray(this.$refs.focusRef)) {
          this.$refs.focusRef[0]?.focus();
        } else {
          this.$refs.focusRef?.focus();
        }
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
    },
    // 保存
    async handleSave(params) {
      for (const key in this.rules) {
        if (!this.form[key]) {
          this.$DonMessage.error(this.rules[key][0].message);
          return;
        }
      }
      try {
        const submitData = JSON.parse(
          JSON.stringify({ ...params, ...this.form })
        );
        const res = await addOrUpdateEconomicEnvironmentApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.third_title {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #1890ff;
  padding: 10px 0 10px 10px;
  // border-bottom: 1px solid #dcdee0;
}
.table_container {
  padding: 15px 18px 0 50px;

  table {
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
  }
  th,
  td {
    border: 1px solid #dcdfe6;
    padding: 4px 12px;
    height: 40px;
    font-size: 14px;
    word-break: break-all;
  }
  th {
    background-color: #f2f2f2;
  }
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
}
</style>
